import logo from "../assets/img/logo.svg";
import { useHistory } from "react-router-dom";

const Header = () => {
  const history = useHistory();
  return (
    <div className="header">
      <img
        src={logo}
        alt={logo}
        onClick={() => {
          history.push("/");
        }}
      />
    </div>
  );
};

export default Header;
